import {EventType} from "../types/EventType";

export function isValidEventTypeId(types: EventType[], typeId: string | null): boolean {
  return types.some(type => typeId === type.id.toString());
}